/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConversionsStatsFromJSON, ConversionsStatsToJSON } from './ConversionsStats';
import { FunnelStatsFromJSON, FunnelStatsToJSON } from './FunnelStats';
import { UsersStatsFromJSON, UsersStatsToJSON } from './UsersStats';
import { VisitsStatsFromJSON, VisitsStatsToJSON } from './VisitsStats';
/**
 * Check if a given object implements the AttributionSummaryResponse interface.
 */
export function instanceOfAttributionSummaryResponse(value) {
    if (!('conversions' in value) || value['conversions'] === undefined)
        return false;
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('funnel' in value) || value['funnel'] === undefined)
        return false;
    if (!('generatedAt' in value) || value['generatedAt'] === undefined)
        return false;
    if (!('truncated' in value) || value['truncated'] === undefined)
        return false;
    if (!('users' in value) || value['users'] === undefined)
        return false;
    if (!('visits' in value) || value['visits'] === undefined)
        return false;
    return true;
}
export function AttributionSummaryResponseFromJSON(json) {
    return AttributionSummaryResponseFromJSONTyped(json, false);
}
export function AttributionSummaryResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'conversions': ConversionsStatsFromJSON(json['conversions']),
        'days': json['days'],
        'funnel': FunnelStatsFromJSON(json['funnel']),
        'generatedAt': (new Date(json['generated_at'])),
        'truncated': json['truncated'],
        'users': UsersStatsFromJSON(json['users']),
        'visits': VisitsStatsFromJSON(json['visits']),
    };
}
export function AttributionSummaryResponseToJSON(json) {
    return AttributionSummaryResponseToJSONTyped(json, false);
}
export function AttributionSummaryResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'conversions': ConversionsStatsToJSON(value['conversions']),
        'days': value['days'],
        'funnel': FunnelStatsToJSON(value['funnel']),
        'generated_at': value['generatedAt'].toISOString(),
        'truncated': value['truncated'],
        'users': UsersStatsToJSON(value['users']),
        'visits': VisitsStatsToJSON(value['visits']),
    };
}
